<template>
  <div>

    <div class="container mt-5" > <!---style="margin-top:1rem; margin-bottom:5rem; height:60vh;"-->
        <div id="formulario-login" v-scroll-reveal>
            <div class="container">
                <div class="row">
                    <div class="d-none d-sm-none d-md-block col-md-5 tramite">
                        <img class="d-none d-md-block w-100 mt-3" src="@/assets/imagenes/cash.jpg" alt="">
                    </div>
                    <div class="col-md-7 login pt-5">

                            <!-- <h6 class="mt-3 text-center text-muted">Administrador de formatos</h6> -->
                            <h4 class="text-center">Organismos Públicos</h4>
                            <form v-on:submit.prevent="conexion()" method="post" class="mt-4">
                                <div class="form-group">
                                    <!-- <label for="usuario">Usuario</label> -->
                                    <input type="text" v-model="login" class="form-control form-control-lg" id="usuario" placeholder="Login" style="font-size:1rem;">
                                </div>
                                <div class="form-group mb-0">
                                    <!-- <label for="password">Contraseña</label> -->
                                    <input type="password" v-model="clave" class="form-control form-control-lg" id="password" placeholder="Clave" style="font-size:1rem;">
                                </div>
                                <div class="mt-3">
                                  <div class="d-flex">
                                  <select v-model="anioSelect" class="form-control">
                                    <option selected>Año</option>
                                    <option v-for="(item, i) in anio" :key="i">{{item.anio}}</option>
                                  </select>
                                  <select v-model="mesSelect" class="form-control">
                                    <option selected>Mes</option>
                                    <option :value="item.id" v-for="(item, i) in mes" :key="i">{{item.mes}}</option>
                                  </select>
                                  <select v-model="quincenaSelect" class="form-control" :disabled="cancelado">
                                    <option selected>Quincena</option>
                                    <option :value="item.id" v-for="(item, i) in quincenaList" :key="i">{{item.quin}}</option>
                                  </select>
                                  </div>
                                  <div>
                                    <input id="cancelado" v-model="cancelado" type="checkbox" aria-label="Checkbox for following text input">
                                    <label for="cancelado" class="text-muted mt-1 ml-2">Cheques Cancelados</label>
                                  </div>
                                </div>
                                <div class="mt-5 mb-0">
                                    <button type="submit" value="Entrar" name="Consultar" class="btn btn-vino-strong py-2 px-5 btn-block">Buscar</button>
                                </div>
                            </form>

                    </div>
                </div>
            </div>
        </div>
    </div>


    <div v-html="data" class="texto-articulo my-4"></div>


  </div>
</template>
<script>
import ArmonizacionProgramaticaSH from "@/services/ArmonizacionContable/secretariaHacienda/ArmonizacionCSHacienda.service.js";
const _serviciosArmonizacionProgramaticaSH = new ArmonizacionProgramaticaSH();
export default {
  data() {
    return{
      data: null,
      login: "",
      clave: "",
      anioSelect: "Año",
      mesSelect: "Mes",
      quincenaSelect: "Quincena",
      cancelado: false,
      anio2: [],
      anio: [ {id: 1, anio: "2022"}, {id: 2, anio: "2023"}, {id: 3, anio: "2024"}],
      mes: [{id: 1, mes: "Enero"},{id: 2, mes: "Febrero"},{id: 3, mes: "Marzo"},{id: 4, mes: "Abril"},{id: 5, mes: "Mayo"},{id: 6, mes: "Junio"},{id: 7, mes: "Julio"},{id: 8, mes: "Agosto"},{id: 9, mes: "Septiembre"},{id: 10, mes: "Octubre"},{id: 11, mes: "Noviembre"},{id: 12, mes: "Diciembre"}],
      quincenaList: [{id:1, quin:"1ra"}, {id:2, quin:"2da"}]
    }
  },
  mounted(){
    this.obtenerAno();
  },
  methods:{
    obtenerAno() {
      let  d = new  Date();
      let  n = d.getFullYear();
      // this.anioSelect = n;
      for(let i=0; i<=2; i++){
        this.anio2.push({id: i+1, anio: n-i})
      }
    },
    async conexion(){
      let payload = {
        Login: this.login,
        Clave: this.clave,
        anio: this.anioSelect,
        mes: this.mesSelect,
        quincena: this.quincenaSelect,
        cancelado: this.cancelado
      }
      try {
            const response = await _serviciosArmonizacionProgramaticaSH.postPrueba(payload);
            console.log('response', response);
            this.data = response;
          } catch (error) {
            console.log('error', error.message);
          }
    },

  },
  watch:{
    cancelado(){
      if(this.cancelado) this.quincenaSelect = "Quincena";
    }
  }
}
</script>
